module.exports = __webpack_public_path__ + "img/header1.20f96a8f.jpg";